import Counter from "./Counter";

// Export without redux connection
export default Counter;
